import { LandingComponentProps, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'

// The /app entry point no longer renders a marketing landing — it drops the user
// straight onto a branded loading interstitial that auto-advances into the funnel
// (first question "What's your weight loss goal?" now lives in ob-kova-glp-1-app).
const schema: LandingScreenSchema = {
	config: { background: 'kova', deferCookieBanner: true },
	order: ['LandingGlpLoader'],
	components: {
		LandingGlpLoader: (): LandingComponentProps.GlpLoader => ({
			duration: 4000,
			subtitle: 'Preparing to check your GLP-1 eligibility',
			title: 'Let’s see if GLP-1 treatment could help you reach your weight loss goals',
		}),
	},
}

export default schema
